import { render, staticRenderFns } from "./DocumentUploadInput.vue?vue&type=template&id=4a842ec8"
import script from "./DocumentUploadInput.vue?vue&type=script&lang=js"
export * from "./DocumentUploadInput.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploadInput.vue?vue&type=style&index=0&id=4a842ec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports